module.exports = __webpack_public_path__ + "img/icon2.09e0a9de.svg";